import { checkForCookie, setCookie } from './cookies';
import { makeRequest, updateForms } from './functions';

function initializeEmailSignup() {
  const COOKIE_NAME = 'athEmailSubmitted';

  if (checkForCookie(COOKIE_NAME)) {
    const headerForm = document.querySelector('#header-form');
    headerForm.remove();
  }

  const emailSignupForms = document.querySelectorAll('.email-signup-form');

  if (emailSignupForms.length > 0) {
    const update = updateForms(emailSignupForms);

    emailSignupForms.forEach((form) => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();

        makeRequest(
          form,
          'ath_send_email',
          ['email'],
          (data) => {
            switch (data.status) {
              case 200:
                update('We have received your message!');
                setCookie(COOKIE_NAME, 1);
                break;
              case 400:
                update('We are sorry, you could not be verified.');
                break;
              default:
                update('There was an issue processing your information.');
            }
          },
          emailSignupForms
        );
      });
    });
  }
}

export { initializeEmailSignup };
